import { render, staticRenderFns } from "./SCS.vue?vue&type=template&id=06d883e8&scoped=true&"
import script from "./SCS.vue?vue&type=script&lang=js&"
export * from "./SCS.vue?vue&type=script&lang=js&"
import style0 from "./SCS.vue?vue&type=style&index=0&id=06d883e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d883e8",
  null
  
)

export default component.exports